import { getConfigs } from '@api/form-verification';
import { INSUFF_CATEGORY, TxnState } from '@global/constants/verification';
import { TxnInfo, VerificationConfig, VerificationsState } from '@global/types/form';
import { updateFormData } from '@redux/slices/form-data';
import { store } from '@redux/store';
import { getProfileModeSelectVerifications } from './profile/mode-select/constants';

export const getVerificationsByCategory = (
  txnInfo: TxnInfo,
  configs: Record<string, VerificationConfig>
) => {
  let formattedConfigs: Record<string, { list: VerificationsState }> = {};
  if (!txnInfo?.verificationList) {
    return formattedConfigs;
  }
  Object.values(txnInfo?.verificationList ?? {})?.forEach((row) => {
    const foundConfig = configs?.[row?.name];
    if (row?.category?.name && foundConfig) {
      const verificationInfo = {
        metadata: foundConfig?.metadata ?? {},
        acceptMultipleSubmissions: foundConfig?.additionalInfo?.acceptMultipleSubmissions ?? false,
        ...row
      };
      const category =
        row?.state === TxnState.INSUFFICIENT_DATA ? INSUFF_CATEGORY : row?.category?.name;

      if (!formattedConfigs?.[category]) {
        formattedConfigs[category] = {
          list: [verificationInfo]
        };
      } else {
        formattedConfigs[category].list = [...formattedConfigs[category].list, verificationInfo];
      }
    }
  });
  // bring 'Action Required' to the top
  if (formattedConfigs?.[INSUFF_CATEGORY]?.list?.length > 0) {
    const temp = structuredClone(formattedConfigs?.[INSUFF_CATEGORY]);
    delete formattedConfigs?.[INSUFF_CATEGORY];
    formattedConfigs = { [INSUFF_CATEGORY]: temp, ...formattedConfigs };
  }
  store.dispatch(
    updateFormData({
      verificationsByCategory: formattedConfigs
    })
  );
};

export const handleFetchConfigs = async (txnInfo: TxnInfo, verificationsForProfile: string) => {
  const txnVerificationNames = Object.keys(txnInfo?.verificationList ?? {}) ?? [];
  const verificationNames = new Set([...txnVerificationNames]);
  if (txnInfo?.manualProfileRequired === false) {
    const profileVerifications = getProfileModeSelectVerifications(verificationsForProfile);
    Object.values(profileVerifications).forEach((name) => verificationNames.add(name));
  }

  const marksheetRequired: { [key: string]: boolean } = {};
  for (const key of Object.keys(txnInfo?.verificationList ?? {})) {
    if (txnInfo?.verificationList?.[key]?.marksheetRequired) {
      marksheetRequired[key] = true;
    }
  }
  const res = await getConfigs(
    Array.from(verificationNames),
    marksheetRequired,
    txnInfo?.verificationList
  );
  if (res?.code === 0) {
    getVerificationsByCategory(txnInfo, res?.data);
  }
};
